import React from 'react';
import { withFormsy } from 'formsy-react';
import { NumericFormat } from 'react-number-format';
import { styled } from '@mui/material';

import BaseTextField, { type FieldProps } from './components/BaseTextField';
import Icon from '../Icon';
import { formatCurrency } from '../Utils';

type CurrencyTextFieldProps = Omit<FieldProps<number>, 'startAdornment' | 'endAdornment'>;

const StyledBaseTextField = styled(BaseTextField)(({ theme }) => ({
	'& > .MuiInputBase-root > .MuiInputAdornment-root > p': {
		lineHeight: 0
	}
}));

/** Field used to display currency-based values */
function CurrencyTextField(props: CurrencyTextFieldProps) {
	const handleChange: React.FocusEventHandler<HTMLInputElement> = event => {
		const newNumberValue = Number.parseFloat(event.target.value?.replaceAll('.', '').replace(',', '.'));
		const newValue = newNumberValue || newNumberValue === 0 ? newNumberValue : null;

		if (props.beforeChange) props.beforeChange(newNumberValue);
		props.sendChange(props.name, newValue);
		props.setValue(newValue);
		if (props.afterChange) props.afterChange(newNumberValue);
	};

	return (
		<NumericFormat
			customInput={StyledBaseTextField}
			className={props.className}
			name={props.name}
			label={props.label}
			value={props.value ?? ''}
			helperText={props.helperText}
			isEdit={props.isEdit}
			endAdornment={<Icon icon="currency-eur" size={20} />}
			required={props.required}
			errorMessage={props.errorMessage}
			isFormSubmitted={props.isFormSubmitted}
			isPristine={props.isPristine}
			isValid={props.isValid}
			logProps={props.logProps}
			fieldParser={formatCurrency}
			onBlur={handleChange}
			thousandSeparator="."
			decimalSeparator=","
			decimalScale={2}
			fixedDecimalScale
		/>
	);
}

export default React.memo(withFormsy(CurrencyTextField));
